import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import clsx from 'clsx';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../Project.css'
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import {
    getProjectTaskTeam, getTaskTeamReminder, addAccountProjectTask, updateAccountProjectTask, updateIsLoading, updateIsLoadingSummary,
    updateIsLoadTaskFields, resetProjectTaskTeam,
    updateLoadingState
} from '../TasksSlice';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { parseLocalizedNumber, formatNumberCustomoriginalapiv2, determineCommaSeprater, formatNumberCustomoriginal, validateCultureNumber, dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import TaskResource from '../resources/TasksResource';
import { AttachmentUpload } from '../../attachment/AttachmentUpload';
import { addAttachment } from '../../attachment/AttachmentSlice';
import GetAttachments from '../../attachment/AttachmentItem';
import CanvasLoader from '../../../common/CanvasLoader';
import { updateIsSummaryLoading } from '../Board/BoardSlice';
import { TOOLTIP_STYLE } from '../../../common/TooltipStyle';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import infoSVG from "../../../assets/image/info-SVG.svg";

const objDropdown = {
    taskTypes: [],
    taskPriority: [],
    taskStatus: [],
    taskDurationUnit: [],
    accountWorkTypes: [],
    employeeCurrencyRate: [],
    billingCurrencyRate: [],
    parentTask: [],
    projectMilestone: [],
    estimatedCostCurrencies: [],
    taskTeamRemainder: []
}

const objTaskValues = {
    accountTaskTypeId: 0,
    // taskCode: '',
    accountTaskPriorityId: 0,
    accountTaskStatusId: 0,
    startDate: new Date(),
    endDate: new Date(),
    systemDurationUnitId: 0,
    systemDurationUnitLabel: '',
    systemDurationUnit: 0,
    isAllProjectEmployeeTask: false,
    isAllProjectTask: false,
    accountWorkTypeId: 0,
    isBillable: false,
    billingRateStartDate: new Date(),
    billingRateEndDate: new Date(),
    employeeRateCurrencyId: 0,
    employeeRate: 0,
    billingRateCurrencyId: 0,
    billingRate: 0,
    parentTaskId: 0,
    accountProjectMilestoneId: 0,
    estimattedCostCurrencyId: 0,
    estimatedCost: 0,
    estimatedTime: 0,
    isParent: false,
    taskTeamRemainderId: 0,
    showReminderDays: 'none',
    reminderDays: 0,
    taskDescription: '',
    taskCompletePercent: 0,
    isDisabled: false,
    isCanvasLoader: true,
    taskYup: {
        taskName: "", taskCode: "",
        CustomField1: "",
        CustomField2: "",
        CustomField3: "",
        CustomField4: "",
        CustomField5: "",
        CustomField6: "",
        CustomField7: "",
        CustomField8: "",
        CustomField9: "",
        CustomField10: "",
        CustomField11: "",
        CustomField12: "",
        CustomField13: "",
        CustomField14: "",
        CustomField15: ""
    }
}

const TaskAddAndUpdate = (props: any) => {
    const { IsFromSummary, AccountProjectId } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [tab, setTab] = useState('Basic');
    const [taskResponse, setTaskResponse] = useState<any | ''>(objDropdown);
    const [taskValues, setTaskValues] = useState<any | ''>(objTaskValues);
    const { accountProjectId, accountProjectTaskId, taskTeamList, addTaskTeamList, deletedTaskTeamList, remainderTeamList, addRemainderTaskTeamList, deletedRemainderTaskTeamList, isLoadTaskFields } = useAppSelector((state) => state.tasks);
    const { decimalPlaces, accountBaseCurrencyId, maxMenuHeight, sessionAccountEmployeeId, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, timeZoneId, isGoogleCalendarAutoSync, isGoogleCalendarTaskAutoSync, isGoogleCalendarTimesheetAutoSync, calendarStartDay, enableUploadFeature } = useAppSelector((state) => state.globalState)
    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const formikRef = useRef<any>(null);
    const [showErrorSummary, setShowErrorSummary] = useState(false);
    const [autoIncludeProjectEmployeesInTasks, setAutoIncludeProjectEmployeesInTasks] = useState(false);
    

    useEffect(() => {
        dispatch(resetProjectTaskTeam());
        if (isLoadTaskFields) {
            getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
                renderTaskFields(result).then((result) => {
                   dispatch(getProjectTaskTeam());
                    accountProjectTaskId != 0 && dispatch(getTaskTeamReminder());
                }).catch((error) => {
                });
            }).catch((error) => {
            });
            setTab('Basic');
            clearAttachmentUpload();
            dispatch(updateIsLoadTaskFields(false));
        }
    }, [accountProjectTaskId, isLoadTaskFields]);

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = 'C9A8F7F1-1B2D-48DA-AAE9-74F92892A896';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const getDefaultValOfSpecificCustomField = (customField: string, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (foundItem) {
            // return foundItem.MasterCustomDataTypeName === 'Date' ? moment().format(CurrentCultureDateFormat.toUpperCase()) : (foundItem.DefaultValue || '');
            return foundItem.MasterCustomDataTypeName === 'Date' ? moment(new Date()).format(customFieldInsertionFormat) : (foundItem.DefaultValue || '');
        } else {
            return '';
        }
    }

    const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
            let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
            
            // Safety check if field definition is not found
            if (!foundItem) return customFieldData;
    
            if (foundItem.MasterCustomDataTypeName === 'Date') {
                return customFieldData;
            } 
            else if (foundItem.MasterCustomDataTypeName === 'Number') {
                if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                    return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
                }
                return customFieldData;
            } 
            else {
                return customFieldData;
            }
        }

    const renderTaskFields = async (customFields: any) => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        setTaskValues({
            ...taskValues,
            isCanvasLoader: true
        })
        // accountProjectTaskId != 0 && dispatch(updateIsLoading(true));
        const response = await fetchAPI(`api/Tasks/GetAllDataInSingleRequest/?AccountProjectId=${accountProjectId}&AccountProjectTaskId=${accountProjectTaskId}`, 'Get', '', true);
        const json = await response.json();
        json["Task Types"].map((item: any) => {
            item.value = item.AccountTaskTypeId;
            item.label = item.TaskType;
            delete item.AccountTaskTypeId;
            delete item.TaskType;
        });
        json["Tasks Priority"].map((item: any) => {
            item.value = item.AccountPriorityId;
            item.label = item.Priority;
            delete item.AccountPriorityId;
            delete item.Priority;
        });
        json["Account Status"].map((item: any) => {
            item.value = item.AccountStatusId;
            item.label = item.Status;
            delete item.AccountStatusId;
            delete item.Status;
        });
        json["SystemDurationUnitId"].map((item: any, index: any) => {
            item.value = item.SystemDurationUnitID;
            item.label = item.SystemDurationUnit;
            delete item.SystemDurationUnitID;
            delete item.SystemDurationUnit;
        });
        json["Account Work Types"].map((item: any) => {
            item.value = item.AccountWorkTypeId;
            item.label = item.AccountWorkType;
            delete item.AccountWorkTypeId;
            delete item.AccountWorkType;
        });
        json["Employee Rate Currency"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        json["Billing Rate Currency"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
        json["Parent Tasks"].map((item: any) => {
            item.value = item.AccountProjectTaskId;
            item.label = item.TaskName;
        });
        json["Parent Tasks"].unshift({ "value": 0, "label": "<Root Level>" });
        json["Project Milestones"].map((item: any) => {
            item.value = item.AccountProjectMilestoneId;
            item.label = item.MilestoneDescription;
            delete item.AccountProjectMilestoneId;
            delete item.MilestoneDescription;
        });
        json["Estimated Cost Currencies"].map((item: any) => {
            item.value = item.AccountCurrencyId;
            item.label = item.CurrencyCode;
            delete item.AccountCurrencyId;
            delete item.CurrencyCode;
        });
       const autoInclude = json?.AutoIncludeProjectEmployeesInTasks ?? false;// State set karein
        setAutoIncludeProjectEmployeesInTasks(autoInclude);
        setTaskValues((prev: any) => ({
            ...prev,
            isAllProjectEmployeeTask: autoInclude ? false : prev.isAllProjectEmployeeTask
        }));
        
        let arrayTaskremainder = [
            { "value": 0, "label": "None" },
            { "value": 1, "label": "Daily" },
            { "value": 2, "label": "On due date" },
            { "value": 3, "label": "Day(s) before due date" },
            { "value": 4, "label": "Day(s) after due date" }
        ];

let formattedBillingRate = ''
let formattedEmployeeRate = ''

if (accountProjectTaskId != 0 && json["AccountWorkTypeBillingRate"].length > 0) {
    const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
    
    if (json["AccountWorkTypeBillingRate"][0].EmployeeRate !== null && 
        json["AccountWorkTypeBillingRate"][0].EmployeeRate !== undefined) {
        formattedEmployeeRate = Number(json["AccountWorkTypeBillingRate"][0].EmployeeRate).toFixed(decimalPlaces);
    }
    
    if (json["AccountWorkTypeBillingRate"][0].BillingRate !== null && 
        json["AccountWorkTypeBillingRate"][0].BillingRate !== undefined) {
        formattedBillingRate = Number(json["AccountWorkTypeBillingRate"][0].BillingRate).toFixed(decimalPlaces);
    }
    
    if (isCommaSeparator) {
        formattedBillingRate = formattedBillingRate.replace('.', ',');
        formattedEmployeeRate = formattedEmployeeRate.replace('.', ',');
    } else if (isCommaSeparator === false) {
        formattedEmployeeRate = formattedEmployeeRate.replace(',', '.');
        formattedBillingRate = formattedBillingRate.replace(',', '.');
    }
}
        setTaskValues({
            ...taskValues,
            taskYup: {
                taskName: accountProjectTaskId != 0 ? json["Account Task"][0].TaskName : '',
                taskCode: accountProjectTaskId != 0 ? json["Account Task"][0].TaskCode : '',
                //estimatedTime: accountProjectTaskId != 0 ? json["Account Task"][0].EstimatedTimeSpent : '',
                // systemDurationUnit: accountProjectTaskId != 0 && json["Account Task"][0].FormattedDuration ? parseFloat(json["Account Task"][0].FormattedDuration.replace(',', '.')) : 0,
                systemDurationUnit: accountProjectTaskId !== 0 && json?.["Account Task"]?.[0]?.FormattedDuration != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json?.["Account Task"][0].FormattedDuration, 2 ): 0,
                estimatedTime: accountProjectTaskId !== 0 && json?.["Account Task"]?.[0]?.EstimatedTimeSpent != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json?.["Account Task"][0].EstimatedTimeSpent, 2 ): 0,
                CustomField1: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField1 ? setCustomFieldValues('CustomField1', json["Account Task"][0].CustomField1, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField1', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField1', customFields),
                CustomField2: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField2 ? setCustomFieldValues('CustomField2', json["Account Task"][0].CustomField2, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField2', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField2', customFields),
                CustomField3: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField3 ? setCustomFieldValues('CustomField3', json["Account Task"][0].CustomField3, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField3', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField3', customFields),
                CustomField4: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField4 ? setCustomFieldValues('CustomField4', json["Account Task"][0].CustomField4, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField4', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField4', customFields),
                CustomField5: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField5 ? setCustomFieldValues('CustomField5', json["Account Task"][0].CustomField5, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField5', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField5', customFields),
                CustomField6: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField6 ? setCustomFieldValues('CustomField6', json["Account Task"][0].CustomField6, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField6', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField6', customFields),
                CustomField7: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField7 ? setCustomFieldValues('CustomField7', json["Account Task"][0].CustomField7, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField7', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField7', customFields),
                CustomField8: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField8 ? setCustomFieldValues('CustomField8', json["Account Task"][0].CustomField8, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField8', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField8', customFields),
                CustomField9: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField9 ? setCustomFieldValues('CustomField9', json["Account Task"][0].CustomField9, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField9', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField9', customFields),
                CustomField10: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField10 ? setCustomFieldValues('CustomField10', json["Account Task"][0].CustomField10, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField10', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField10', customFields),
                CustomField11: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField11 ? setCustomFieldValues('CustomField11', json["Account Task"][0].CustomField11, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField11', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField11', customFields),
                CustomField12: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField11 ? setCustomFieldValues('CustomField12', json["Account Task"][0].CustomField12, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField12', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField12', customFields),
                CustomField13: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField13 ? setCustomFieldValues('CustomField13', json["Account Task"][0].CustomField13, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField13', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField13', customFields),
                CustomField14: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField14 ? setCustomFieldValues('CustomField14', json["Account Task"][0].CustomField14, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField14', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField14', customFields),
                CustomField15: accountProjectTaskId != 0 ?
                    (json["Account Task"][0].CustomField15 ? setCustomFieldValues('CustomField15', json["Account Task"][0].CustomField15, customFields) 
					: getDefaultValOfSpecificCustomField('CustomField15', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField15', customFields),

            },
            accountTaskTypeId: accountProjectTaskId != 0 ? json["Account Task"][0].AccountTaskTypeId : json["Task Types"][0].value,
            // taskCode: accountProjectTaskId != 0 ? json["Account Task"][0].TaskCode : '',
            accountTaskPriorityId: accountProjectTaskId != 0 ? json["Account Task"][0].AccountPriorityId : json["Tasks Priority"][0].value,
            accountTaskStatusId: accountProjectTaskId != 0 ? json["Account Task"][0].TaskStatusId : json["Account Status"][0].value,
            // startDate: accountProjectTaskId != 0 ? new Date(json["Account Task"][0].StartDate) : new Date(),
            // endDate: accountProjectTaskId != 0 ? new Date(json["Account Task"][0].DeadlineDate) : new Date(),
            startDate: accountProjectTaskId != 0 ? dateFormatByAccountCulture(moment.parseZone(json["Account Task"][0].StartDate).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            endDate: accountProjectTaskId != 0 ? dateFormatByAccountCulture(moment.parseZone(json["Account Task"][0].DeadlineDate).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date(),
            systemDurationUnitId: accountProjectTaskId != 0 ? json["Account Task"][0].SystemDurationUnitID : json["SystemDurationUnitId"].filter((x: any) => x.value == 3)[0].value,
            systemDurationUnitLabel: accountProjectTaskId != 0 ? json["SystemDurationUnitId"].filter((x: any) => x.value == json["Account Task"][0].SystemDurationUnitID)[0].label : json["SystemDurationUnitId"].filter((x: any) => x.value == 3)[0].label,
           // systemDurationUnit: accountProjectTaskId != 0 ? json["Account Task"][0].FormattedDuration : 0,
            isAllProjectEmployeeTask: accountProjectTaskId != 0 ? json["Account Task"][0].IsForAllEmployees : false,
            isAllProjectTask: accountProjectTaskId != 0 ? json["Account Task"][0].IsForAllProjectTask : false,
            // accountWorkTypeId: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"][0].AccountWorkTypeId : json["Account Work Types"][0].value,    
            // isBillable: accountProjectTaskId != 0 ? json["Account Task"][0].IsBillable : false,
            // billingRateStartDate: accountProjectTaskId != 0 ? new Date(json["AccountWorkTypeBillingRate"][0].StartDate) : new Date(),
            // billingRateEndDate: accountProjectTaskId != 0 ? new Date(json["AccountWorkTypeBillingRate"][0].EndDate) : new Date(),
            // employeeRateCurrencyId: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"][0].EmployeeRateCurrencyId : json["Employee Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value,
            // employeeRate: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"][0].EmployeeRate : 0,
            // billingRateCurrencyId: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"][0].BillingRateCurrencyId : json["Billing Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value,
            // billingRate: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"][0].BillingRate : 0,
            accountWorkTypeId: accountProjectTaskId != 0 ? json["AccountWorkTypeBillingRate"].length > 0 ? json["AccountWorkTypeBillingRate"][0].AccountWorkTypeId : json["Account Work Types"][0].value : json["Account Work Types"][0].value,
            isBillable: accountProjectTaskId != 0 ? json["Account Task"][0].IsBillable : false,
            // billingRateStartDate: accountProjectTaskId != 0 ?
            //     json["AccountWorkTypeBillingRate"].length > 0 ? new Date(json["AccountWorkTypeBillingRate"][0].StartDate) : new Date()
            //     : new Date(),
            // billingRateEndDate: accountProjectTaskId != 0 ?
            //     json["AccountWorkTypeBillingRate"].length > 0 ? new Date(json["AccountWorkTypeBillingRate"][0].EndDate) : new Date()
            //     : new Date(),
            billingRateStartDate: accountProjectTaskId != 0 ?
                json["AccountWorkTypeBillingRate"].length > 0 ? dateFormatByAccountCulture(moment.parseZone(json["AccountWorkTypeBillingRate"][0].StartDate).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date()
                : new Date(),
            billingRateEndDate: accountProjectTaskId != 0 ?
                json["AccountWorkTypeBillingRate"].length > 0 ? dateFormatByAccountCulture(moment.parseZone(json["AccountWorkTypeBillingRate"][0].EndDate).format('YYYY-MM-DD'), cultureInfoName.toString()) : new Date()
                : new Date(),
            employeeRateCurrencyId: accountProjectTaskId != 0 ?
                json["AccountWorkTypeBillingRate"].length > 0 ? json["AccountWorkTypeBillingRate"][0].EmployeeRateCurrencyId : json["Employee Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value
                : json["Employee Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value,
            employeeRate: formattedEmployeeRate,
            billingRateCurrencyId: accountProjectTaskId != 0 ?
                json["AccountWorkTypeBillingRate"].length > 0 ? json["AccountWorkTypeBillingRate"][0].BillingRateCurrencyId : json["Billing Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value
                : json["Billing Rate Currency"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value,
            billingRate: formattedBillingRate,
            parentTaskId: accountProjectTaskId != 0 ? (json["Account Task"][0].ParentAccountProjectTaskId != null ? json["Account Task"][0].ParentAccountProjectTaskId : json["Parent Tasks"][0].value) : json["Parent Tasks"][0].value,
            accountProjectMilestoneId: accountProjectTaskId != 0 ? json["Account Task"][0].AccountProjectMilestoneId : json["Project Milestones"][0].value,
            estimattedCostCurrencyId: accountProjectTaskId != 0 ? json["Account Task"][0].EstimatedCurrencyId : json["Estimated Cost Currencies"].filter((x: any) => x.value == accountBaseCurrencyId)[0].value,
            estimatedCost: accountProjectTaskId != 0 && json?.["Account Task"]?.[0]?.EstimatedCost != null ? formatNumberCustomoriginalapiv2(cultureInfoName.toString(), json?.["Account Task"][0].EstimatedCost, decimalPlaces ): formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),
            estimatedTime: accountProjectTaskId != 0 ? json["Account Task"][0].EstimatedTimeSpent : 0,
            isParent: accountProjectTaskId != 0 ? json["Account Task"][0].IsParentTask : false,
            taskTeamRemainderId: accountProjectTaskId != 0 ? json["Account Task"][0].ReminderTypeId : 0,
            showReminderDays: accountProjectTaskId != 0 ? (json["Account Task"][0].ReminderTypeId == 3 || json["Account Task"][0].ReminderTypeId == 4) ? 'flex' : ' none' : 'none',
            reminderDays: accountProjectTaskId != 0 ? json["Account Task"][0].ReminderDays : 0,
            taskDescription: accountProjectTaskId != 0 ? json["Account Task"][0].TaskDescription : "",
            taskCompletePercent: accountProjectTaskId != 0 ? json["Account Task"][0].FormattedCompletedPercent : 0,
            isDisabled: accountProjectTaskId != 0 ? json["Account Task"][0].IsDisabled : false,
            isCanvasLoader: false
        });
        setTaskResponse({
            ...taskResponse,
            taskTypes: json["Task Types"],
            taskPriority: json["Tasks Priority"],
            taskStatus: json["Account Status"],
            taskDurationUnit: json["SystemDurationUnitId"].filter((x: any) => x.value != 2 && x.value != 4 && x.value != 5 && x.value != 6 && x.value != 7 && x.value != 8),
            accountWorkTypes: json["Account Work Types"],
            employeeCurrencyRate: json["Employee Rate Currency"],
            billingCurrencyRate: json["Billing Rate Currency"],
            parentTask: json["Parent Tasks"],
            projectMilestone: json["Project Milestones"],
            estimatedCostCurrencies: json["Estimated Cost Currencies"],
            taskTeamRemainder: arrayTaskremainder
        });
    }

    const onChange = (data: any, filterName: any) => {
        const { accountTaskTypeId, accountTaskPriorityId, accountTaskStatusId, systemDurationUnitId, systemDurationUnitLabel, accountWorkTypeId,
            employeeRateCurrencyId, billingRateCurrencyId, parentTaskId, accountProjectMilestoneId, estimattedCostCurrencyId, taskTeamRemainderId
        } = taskValues;
        setTaskValues({
            ...taskValues,
            accountTaskTypeId: filterName.name == "taskTypeArray" ? taskResponse.taskTypes.filter((x: any) => x.value == data.value)[0].value : accountTaskTypeId,
            accountTaskPriorityId: filterName.name == "taskPriorityArray" ? taskResponse.taskPriority.filter((x: any) => x.value == data.value)[0].value : accountTaskPriorityId,
            accountTaskStatusId: filterName.name == "taskStatusArray" ? taskResponse.taskStatus.filter((x: any) => x.value == data.value)[0].value : accountTaskStatusId,
            systemDurationUnitId: filterName.name == "taskDurationArray" ? taskResponse.taskDurationUnit.filter((x: any) => x.value == data.value)[0].value : systemDurationUnitId,
            systemDurationUnitLabel: filterName.name == "taskDurationArray" ? taskResponse.taskDurationUnit.filter((x: any) => x.value == data.value)[0].label : systemDurationUnitLabel,
            accountWorkTypeId: filterName.name == "accountWorkTypesArray" ? taskResponse.accountWorkTypes.filter((x: any) => x.value == data.value)[0].value : accountWorkTypeId,
            employeeRateCurrencyId: filterName.name == "employeeCurrencyArray" ? taskResponse.employeeCurrencyRate.filter((x: any) => x.value == data.value)[0].value : employeeRateCurrencyId,
            billingRateCurrencyId: filterName.name == "billingRateCurrencyArray" ? taskResponse.billingCurrencyRate.filter((x: any) => x.value == data.value)[0].value : billingRateCurrencyId,
            parentTaskId: filterName.name == "parentTaskArray" ? taskResponse.parentTask.filter((x: any) => x.value == data.value)[0].value : parentTaskId,
            accountProjectMilestoneId: filterName.name == "projectMilestoneArray" ? taskResponse.projectMilestone.filter((x: any) => x.value == data.value)[0].value : accountProjectMilestoneId,
            estimattedCostCurrencyId: filterName.name == "estimatedCostCurrenciesArray" ? taskResponse.estimatedCostCurrencies.filter((x: any) => x.value == data.value)[0].value : estimattedCostCurrencyId,
            taskTeamRemainderId: filterName.name == "taskTeamRemainderArray" ? taskResponse.taskTeamRemainder.filter((x: any) => x.value == data.value)[0].value : taskTeamRemainderId,
            showReminderDays: filterName.name == "taskTeamRemainderArray" ? data.value == 3 || data.value == 4 ? 'flex' : ' none' : 'none',
            employeeRate: taskResponse.employeeRate !== undefined ? taskResponse.employeeRate : '',
            billingRate: taskResponse.billingRate !== undefined ? taskResponse.billingRate : '',
        });
    }

    const onHandleTextChange = (e: any) => {
        setTaskValues({ ...taskValues, [e.target.name]: e.target.value })
    }

    const onDateChange = (date: any, name: any) => {
        const { startDate, endDate, billingRateStartDate, billingRateEndDate } = taskValues;
        setTaskValues({
            ...taskValues,
            startDate: name == "startDate" ? date : startDate,
            endDate: name == "endDate" ? date : endDate,
            billingRateStartDate: name == "billingRateStartDate" ? date : billingRateStartDate,
            billingRateEndDate: name == "billingRateEndDate" ? date : billingRateEndDate
        })
    }

    const onSwitch = (data: any) => {
        let switchName = data.target.name;
        const { isAllProjectEmployeeTask, isAllProjectTask, isBillable, isParent, isDisabled } = taskValues;
        setTaskValues({
            ...taskValues,
            isAllProjectEmployeeTask: switchName == "isAllProjectEmployeeTask" ? isAllProjectEmployeeTask ? false : true : isAllProjectEmployeeTask,
            isAllProjectTask: switchName == "isAllProjectTask" ? isAllProjectTask ? false : true : isAllProjectTask,
            isBillable: switchName == "isBillable" ? isBillable ? false : true : isBillable,
            isParent: switchName == "isParent" ? isParent ? false : true : isParent,
            isDisabled: switchName == "isDisabled" ? isDisabled ? false : true : isDisabled
        });
    }

    const onAddUpdateTask = (validateValue: any) => {
        IsFromSummary ? dispatch(updateIsLoadingSummary(true)) : dispatch(updateIsLoading(true));
        const { accountTaskTypeId, accountTaskPriorityId, accountTaskStatusId, startDate, endDate, systemDurationUnitId, systemDurationUnitLabel, systemDurationUnit,
            isAllProjectEmployeeTask, isAllProjectTask, accountWorkTypeId, isBillable, billingRateStartDate, billingRateEndDate, employeeRateCurrencyId,
            employeeRate, billingRateCurrencyId, billingRate, parentTaskId, accountProjectMilestoneId, estimattedCostCurrencyId, estimatedCost, estimatedTime,
            isParent, taskTeamRemainderId, reminderDays, taskDescription, taskCompletePercent, isDisabled
        } = taskValues;
        let teamArray: any[] = [];
        let reminderTeamArray: any[] = [];
        if (accountProjectTaskId == 0) {
            taskTeamList.map((item: any) => {
                if (item.IncludeTeam == 1) {
                    teamArray.push(item.Id)
                }
            });
            remainderTeamList.map((item: any) => {
                if (item.IncludeTeam == 1) {
                    reminderTeamArray.push(item.Id)
                }
            });

            const normalizedemployeeRate = parseLocalizedNumber(employeeRate);
            const normalizedbillingRate = parseLocalizedNumber(billingRate);
            const normalizedestimatedCost = parseLocalizedNumber(estimatedCost);
            let objectAdd = {
                AccountProjectId: accountProjectId,
                TaskName: validateValue.taskName,
                AccountTaskTypeId: accountTaskTypeId,
                // TaskCode: taskCode,
                TaskCode: validateValue.taskCode,
                AccountPriorityId: accountTaskPriorityId,
                TaskStatusId: accountTaskStatusId,
                StartDate: moment(startDate).format(dateInsertionFormat),
                DeadlineDate: moment(endDate).format(dateInsertionFormat),
                DurationUnit: systemDurationUnitLabel,
                duration: parseLocalizedNumber(systemDurationUnit),
                IsForAllEmployees: isAllProjectEmployeeTask,
                IsForAllProjectTask: isAllProjectTask,
                AccountWorkTypeId: accountWorkTypeId,
                IsBillable: isBillable,
                BillingRateStartDate: moment(billingRateStartDate).format(dateInsertionFormat),
                BillingRateEndDate: moment(billingRateEndDate).format(dateInsertionFormat),
                EmployeeRateCurrencyId: employeeRateCurrencyId,
                EmployeeRate: normalizedemployeeRate,
                BillingRateCurrencyId: billingRateCurrencyId,
                BillingRate: normalizedbillingRate,
                ParentAccountProjectTaskId: parentTaskId == 0 ? null : parentTaskId,
                AccountProjectMilestoneId: accountProjectMilestoneId,
                EstimatedCurrencyId: estimattedCostCurrencyId,
                EstimatedCost: normalizedestimatedCost,
                EstimatedTimeSpent: parseLocalizedNumber(estimatedTime),
                IsParentTask: isParent,
                ReminderTypeId: taskTeamRemainderId,
                ReminderDays: reminderDays,
                TaskDescription: taskDescription,
                CompletedPercent: taskCompletePercent,
                IsDisabled: isDisabled,
                SystemDurationUnitId: systemDurationUnitId,
                Team: teamArray.toString(),
                ReminderTeam: accountProjectTaskId != 0 ? reminderTeamArray : reminderTeamArray.toString(),
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15),
                timeZoneId: timeZoneId
            }
            if (taskTeamRemainderId == 0) {
                delete objectAdd.ReminderTypeId;
                delete objectAdd.ReminderDays;
            }
            dispatch(addAccountProjectTask(objectAdd)).then((result) => {
                dispatch(updateIsSummaryLoading(true))
                dispatch(updateLoadingState(true))
                if (result.payload.constructor == Array) {
                    const taskId = result.payload[0].id;
                    tempAttachmentId != null && dispatch(addAttachment({ Id: taskId, IsEdit: false, tempAttachmentId: tempAttachmentId, AccountAttachmentTypeId: 5 }));
                    // if (closeButtonRef.current) {
                    //     closeButtonRef.current.click();
                    // }
                    if (Number(result.payload[0].id) > 0) {
                        if (closeButtonRef.current) {
                            closeButtonRef.current.click();
                        }

                        ShowToast('Success', result.payload[0].message, "success", "toast-top-right");
                        // setTimeout(() => {
                        //     if (closeButtonRef.current) {
                        //         closeButtonRef.current.click();
                        //     }
                        // }, 1000);
                    }
                    else {
                        ShowToast('error', "Account Project Task Added Failed", "error", "toast-top-right");
                    }
                    // Number(result.payload[0].id) > 0 ?
                    //     ShowToast('Success', result.payload[0].message, "success", "toast-top-right") :
                    //     ShowToast('error', "Account Project Task Added Failed", "error", "toast-top-right");
                } else {
                    ShowToast('error', result.payload.message, "error", "toast-top-right");
                }
            }).catch((error) => {
            });
        } else {
            addTaskTeamList.map((item) => {
                teamArray.push({
                    "AccountEmployeeId": item.Id,
                    "AccountProjectId": accountProjectId,
                    "isAdd": true
                })
            });
            deletedTaskTeamList.map((item) => {
                teamArray.push({
                    "AccountEmployeeId": item.Id,
                    "AccountProjectId": accountProjectId,
                    "isAdd": false
                })
            });
            const seen = new Map();
            teamArray.forEach((item: any) => {
                const existing = seen.get(item.AccountEmployeeId);
                if (!existing) {
                    seen.set(item.AccountEmployeeId, item);
                } else {
                    if (item.isAdd === true) {
                        seen.set(item.AccountEmployeeId, item);
                    }
                }
            });
            teamArray = Array.from(seen.values());
            addRemainderTaskTeamList.map((item) => {
                reminderTeamArray.push({ "AccountEmployeeId": item.Id, "AccountProjectId": accountProjectId, "isAdd": true });
            });
            deletedRemainderTaskTeamList.map((item) => {
                reminderTeamArray.push({ "AccountEmployeeId": item.Id, "AccountProjectId": accountProjectId, "isAdd": false });
            });
                        const normalizedemployeeRate = parseLocalizedNumber(employeeRate);
            const normalizedbillingRate = parseLocalizedNumber(billingRate);
            const normalizedestimatedCost = parseLocalizedNumber(estimatedCost);
            let objTaskEdit = {
                Task: {
                    AccountProjectId: accountProjectId,
                    TaskName: validateValue.taskName,
                    AccountTaskTypeId: accountTaskTypeId,
                    //TaskCode: taskCode,
                    TaskCode: validateValue.taskCode,
                    AccountPriorityId: accountTaskPriorityId,
                    TaskStatusId: accountTaskStatusId,
                    StartDate: moment(startDate).format(dateInsertionFormat),//startDate,
                    DeadlineDate: moment(endDate).format(dateInsertionFormat),//endDate,
                    DurationUnit: systemDurationUnitLabel,
                    duration: parseLocalizedNumber(validateValue.systemDurationUnit), //parseLocalizedNumber(systemDurationUnit),
                    IsForAllEmployees: isAllProjectEmployeeTask,
                    IsForAllProjectTask: isAllProjectTask,
                    ParentAccountProjectTaskId: parentTaskId == 0 ? null : parentTaskId,
                    AccountProjectMilestoneId: accountProjectMilestoneId,
                    EstimatedCurrencyId: estimattedCostCurrencyId,
                    EstimatedCost: normalizedestimatedCost,
                    EstimatedTimeSpent: parseLocalizedNumber(estimatedTime),
                    IsParentTask: isParent,
                    ReminderTypeId: taskTeamRemainderId,
                    ReminderDays: reminderDays,
                    TaskDescription: taskDescription,
                    CompletedPercent: taskCompletePercent,
                    IsDisabled: isDisabled,
                    SystemDurationUnitId: systemDurationUnitId,
                    IsBillable: isBillable,
                CustomField1: getFormattedCustomField('CustomField1', validateValue.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', validateValue.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', validateValue.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', validateValue.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', validateValue.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', validateValue.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', validateValue.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', validateValue.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', validateValue.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', validateValue.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', validateValue.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', validateValue.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', validateValue.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', validateValue.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', validateValue.CustomField15),
                    timeZoneId: timeZoneId
                },
                Billing: {
                    AccountWorkTypeId: accountWorkTypeId,
                    BillingRateStartDate: moment(billingRateStartDate).format(dateInsertionFormat),
                    BillingRateEndDate: moment(billingRateEndDate).format(dateInsertionFormat),
                    EmployeeRateCurrencyId: employeeRateCurrencyId,
                    EmployeeRate: normalizedemployeeRate,
                    BillingRateCurrencyId: billingRateCurrencyId,
                    BillingRate: normalizedbillingRate
                },
                Team: teamArray,
                ReminderTeam: reminderTeamArray
            }
            if (taskTeamRemainderId == 0) {
                delete objTaskEdit.Task.ReminderTypeId;
                delete objTaskEdit.Task.ReminderDays;
            }
            dispatch(updateAccountProjectTask(objTaskEdit)).then((result) => {
                dispatch(updateIsLoadingSummary(false));
                dispatch(updateIsSummaryLoading(true));
                dispatch(updateLoadingState(true));

                if (result.payload && Array.isArray(result.payload)) {
                    if (Number(result.payload[0].id) > 0) {
                        if (closeButtonRef.current) {
                            closeButtonRef.current.click();
                        }     
                        let taskName = objTaskEdit.Task.TaskName
                        if (taskName.length > 30) {
                            taskName = taskName.substring(0, 30) + "...";
                        }
                        ShowToast(
                            'success',
                            `${taskName} updated successfully.`,
                            "success",
                            "toast-top-right",
                            300,
                            300,
                            7000 
                        );                        
                    } else {
                        ShowToast('error', "Task Update Failed", "error", "toast-top-right");
                    }
                } else {
                    const errorMessage = result.payload?.message || "Account Project Task Update Failed";
                    ShowToast('error', errorMessage, "error", "toast-top-right");
                }
            }).catch((error) => {               
                ShowToast('error', "An unexpected error occurred.", "error", "toast-top-right");
            });
           

        }
        clearAttachmentUpload();
        // resetAllFields();
    }

    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    }

    const clearAttachmentUpload = () => {
        if (attachmentUploadClearRef.current) {
            attachmentUploadClearRef.current();
        }
    }

    const resetAllFields = () => {
        setTab('Basic');
        dispatch(resetProjectTaskTeam());
        setTaskValues({
            ...taskValues,
            accountTaskTypeId: 0,
            // taskCode: '',
            accountTaskPriorityId: 0,
            accountTaskStatusId: 0,
            startDate: new Date(),
            endDate: new Date(),
            systemDurationUnitId: 0,
            systemDurationUnitLabel: '',
            systemDurationUnit: 0,
            isAllProjectEmployeeTask: false,
            isAllProjectTask: false,
            accountWorkTypeId: 0,
            isBillable: false,
            billingRateStartDate: new Date(),
            billingRateEndDate: new Date(),
            employeeRateCurrencyId: 0,
            employeeRate: 0,
            billingRateCurrencyId: 0,
            billingRate: 0,
            parentTaskId: 0,
            accountProjectMilestoneId: 0,
            estimattedCostCurrencyId: 0,
            estimatedCost: 0,
            estimatedTime: 0,
            isParent: false,
            taskTeamRemainderId: 0,
            showReminderDays: 'none',
            reminderDays: 0,
            taskDescription: '',
            taskCompletePercent: 0,
            isDisabled: false,
            taskYup: { taskName: "", taskCode: "" }
        });
    }

    const handleCloseOnClickEvent = () => {
        resetAllFields();
    }

    const validationSchema = yup.object().shape({
        taskName: yup
            .string()
            .label('Task Name')
            .required()
            .max(200, getValueFromResource('Task Name must not exceed 200 Characters', dispatch, t)),
        taskCode: yup
            .string()
            .label(t('Task Code'))
            .max(30, getValueFromResource('Task Code must not exceed 30 Characters', dispatch, t)),
        // systemDurationUnit: yup
        //     .number()
        //     .typeError(getValueFromResource('Duration must be a number', dispatch, t))
        //     .positive(getValueFromResource('Duration must be a positive number', dispatch, t))
        //     .min(0, getValueFromResource('Duration cannot be negative', dispatch, t))
        //     .nullable(),
        systemDurationUnit: yup
            .string() 
            .label(getValueFromResource('Duration', dispatch, t))
            .trim()          
            .test(
                'culture-format-check',
                () => {
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    return isComma
                        ? "Only numbers and comma (,) are allowed."
                        : "Only numbers and dot (.) are allowed.";
                },
                (value) => {
                    if (!value) return true; 
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    if (isComma) {
                        return /^\d+(,\d+)?$/.test(value); 
                    } else {
                        return /^\d+(\.\d+)?$/.test(value); 
                    }
                }
            )
            .test(
                'positive-check',
                getValueFromResource('Duration must be a positive number', dispatch, t),
                (value) => {
                    if (!value) return true; // allow empty
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    const numericValue = isComma
                        ? parseFloat(value.replace(',', '.'))
                        : parseFloat(value);
                    return numericValue >= 0;
                }
            )
            .nullable(),

  
        // estimatedTime: yup
        //     .number()
        //     .typeError(getValueFromResource('Estimate Hour must be a number', dispatch, t))
        //     .positive(getValueFromResource('Estimate Hour must be a positive number', dispatch, t))
        //     .min(0, getValueFromResource('Estimate Hour cannot be negative', dispatch, t))
        //     .nullable(),
        estimatedTime: yup
            .string() 
            .label(getValueFromResource('Estimate Hour', dispatch, t))
            .trim()
            .test(
                'culture-format-check',
                () => {
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    return isComma
                        ? "Only numbers and comma (,) are allowed."
                        : "Only numbers and dot (.) are allowed.";
                },
                (value) => {
                    if (!value) return true;
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    if (isComma) {
                        return /^\d+(,\d+)?$/.test(value); 
                    } else {
                        return /^\d+(\.\d+)?$/.test(value); 
                    }
                }
            )
            .test(
                'positive-check',
                getValueFromResource('Estimate Hour must be a positive number', dispatch, t),
                (value) => {
                    if (!value) return true; 
                    const isComma = determineCommaSeprater(cultureInfoName.toString());
                    const numericValue = isComma
                        ? parseFloat(value.replace(',', '.'))
                        : parseFloat(value);
                    return numericValue >= 0;
                }
            )
            .nullable(),

        ...Object.fromEntries(
            customFieldsArray
                .filter((x: any) => !x.IsDisabled)
                .map((x: any) => {
                    let yupSchema;
                    if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                    }
                    else if (x.MasterCustomDataTypeName === 'Text') {
                        // Assuming it's a text field
                        yupSchema = yup.string().trim();
                        if (x.MaximumLength != null) {
                            yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                        }
                    }
                    else if (x.MasterCustomDataTypeName === 'Date') {
                        yupSchema = yup.date()
                            .nullable()
                            //.required(`${x.CustomFieldCaption} is required`)
                            .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                            .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                    }
                    if (x.IsRequired) {
                        yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                    }
                    return [x.DatabaseFieldName, yupSchema];
                })
        ),
    });

    const handleBlurValidateAll = (setFieldTouched: any, values: any, validateForm: any) => {
        // Mark all fields as touched
        Object.keys(values).forEach(field => {
            setFieldTouched(field, true);
        });
        // Validate all fields
        validateForm();
    }

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={taskValues.taskYup}
                enableReinitialize={true}
                onSubmit={values => {
                    onAddUpdateTask(values)
                }}
                validationSchema={validationSchema}
            // validationSchema={yup.object().shape({
            //     taskName: yup
            //         .string()
            //         .label('Task Name')
            //         .required()
            //         .max(200, 'Task Name must not exceed 200 Characters'),
            //     taskCode: yup
            //         .string()
            //         .label(t('Task Code'))
            //         .max(30, 'Task Code must not exceed 30 Characters')
            // })}
            >
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit, validateForm, setFieldValue }) => (
                    <Fragment>
                        <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <label className="required form-label fs-7 fw-normal mb-2">
                                        {/* {t('Task Name')} */}
                                        {getValueFromResource('Task Name', dispatch, t)}
                                    </label>
                                    <input
                                        value={values.taskName}
                                        type="text"
                                        className="form-control fs-7 fw-normal"
                                        placeholder=
                                        // {t('Task Name')}
                                        {getValueFromResource('Task Name', dispatch, t)}
                                        autoCapitalize="none"
                                        ref={defaultFocusRef}
                                        onChange={handleChange('taskName')}
                                        onBlur={() => setFieldTouched('taskName')}
                                    // onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                    />
                                    <div>
                                        {touched.taskName && errors.taskName &&
                                            <p className='errorMsg'>{errors.taskName as string}</p>
                                        }
                                    </div>
                                </div>
                            </div>
                            {taskValues.isCanvasLoader ? <CanvasLoader /> : <>

                                <div className='card-header' style={{ marginLeft: '-30px' }}>
                                    <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist' style={{ marginTop: 8 }}>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Basic' })}
                                                onClick={() => setTab('Basic')}
                                                role='tab'
                                            >
                                                {/* {t('Basic')} */}
                                                {getValueFromResource('Basic', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Team' })}
                                                onClick={() => setTab('Team')}
                                                role='tab'
                                            >
                                                {/* {t('Team')} */}
                                                {getValueFromResource('Team', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Billing' })}
                                                onClick={() => setTab('Billing')}
                                                role='tab'
                                            >
                                                {/* {t('Billing')} */}
                                                {getValueFromResource('Billing', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Advanced' })}
                                                onClick={() => setTab('Advanced')}
                                                role='tab'
                                            >
                                                {/* {t('Advanced')} */}
                                                {getValueFromResource('Advanced', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Reminders' })}
                                                onClick={() => setTab('Reminders')}
                                                role='tab'
                                            >
                                                {/* {t('Reminders')} */}
                                                {getValueFromResource('Reminders', dispatch, t)}
                                            </a>
                                        </li>
                                        <li className='nav-item'>
                                            <a
                                                className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Other' })}
                                                onClick={() => setTab('Other')}
                                                role='tab'
                                            >
                                                {/* {t('Other')} */}
                                                {getValueFromResource('Other', dispatch, t)}
                                            </a>
                                        </li>
                                        {enableUploadFeature &&
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Attachment' })}
                                                    onClick={() => setTab('Attachment')}
                                                    role='tab'
                                                >
                                                    {/* {t('Attachment')} */}
                                                    {getValueFromResource('Attachment', dispatch, t)}
                                                </a>
                                            </li>}
                                        {customFieldsArray && customFieldsArray.length > 0 &&
                                            <li className='nav-item'>
                                                <a
                                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'CustomField' })}
                                                    onClick={() => setTab('CustomField')}
                                                    role='tab'
                                                >
                                                    {/* {t('Custom Field')} */}
                                                    {getValueFromResource('Custom Field', dispatch, t)}
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <div className='tab-content pt-6'>
                                    <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Task Type')} */}
                                                    {getValueFromResource('Task Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Categorize the task based on its purpose, such as Task, Issue, Bug, or any custom type: Development, Testing, Support, Administration, etc.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={taskResponse.taskTypes.filter((x: any) => x.value == taskValues.accountTaskTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="taskTypeArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.taskTypes}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Task Code')} */}
                                                    {getValueFromResource('Task Code', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('A unique identifier used to reference the task in timesheets, reports, and integrations', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="taskCode"
                                                    className="form-control fs-7 fw-normal"
                                                    id='taskCode'
                                                    value={values.taskCode}
                                                    onChange={handleChange('taskCode')}
                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                />
                                                <div>
                                                    {touched.taskCode && errors.taskCode &&
                                                        <p className='errorMsg'>{errors.taskCode as string}</p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Priority')} */}
                                                    {getValueFromResource('Priority', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.taskPriority.filter((x: any) => x.value == taskValues.accountTaskPriorityId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="taskPriorityArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.taskPriority}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Task Status')} */}
                                                    {getValueFromResource('Task Status', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.taskStatus.filter((x: any) => x.value == taskValues.accountTaskStatusId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="taskStatusArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.taskStatus}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Start Date')} */}
                                                    {getValueFromResource('Start Date', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={taskValues.startDate}
                                                        onChange={(date) => onDateChange(date, "startDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('End Date')} */}
                                                    {getValueFromResource('End Date', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={taskValues.endDate}
                                                        onChange={(date) => onDateChange(date, "endDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Duration (Unit)')} */}
                                                    {getValueFromResource('Duration (Unit)', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.taskDurationUnit.filter((x: any) => x.value == taskValues.systemDurationUnitId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="taskDurationArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.taskDurationUnit}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Duration')} */}
                                                    {getValueFromResource('Duration', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <div className="innerTextField me-7">{taskValues.systemDurationUnitLabel}</div>
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='systemDurationUnit'
                                                        // value={taskValues.systemDurationUnit}
                                                        // onChange={onHandleTextChange}
                                                        value={values.systemDurationUnit}
                                                        onChange={(e) => {
                                                            onHandleTextChange(e);
                                                            handleChange('systemDurationUnit')(e);
                                                        }}
                                                        min="0"
                                                        step="any"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            {!autoIncludeProjectEmployeesInTasks && (
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t(`All Project Employee Task`)} */}
                                                    {getValueFromResource('All Project Employee Task', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Make this task available to all employees assigned to the project without requiring individual task assignments', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input
                                                        className="form-check-input h-20px w-30px"
                                                        type='checkbox'
                                                        //id='kt_builder_sidebar_minimize_desktop_hoverable'
                                                        name='isAllProjectEmployeeTask'
                                                        checked={taskValues.isAllProjectEmployeeTask}
                                                        onChange={(e) => { onSwitch(e) }}
                                                    />
                                                </div>
                                            </div>)}
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t(`All Project Task`)} */}
                                                    {getValueFromResource('All Project Task', dispatch, t)}
                                                </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input
                                                        className="form-check-input h-20px w-30px"
                                                        type='checkbox'
                                                        name='isAllProjectTask'
                                                        checked={taskValues.isAllProjectTask}
                                                        onChange={(e) => { onSwitch(e) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Team' })}>
                                        <TaskResource name="TaskTeam" />
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Billing' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Work Type')} */}
                                                    {getValueFromResource('Work Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Defines the nature of work performed for this task, such as Regular, Overtime, Remote, or another configured work type.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={taskResponse.accountWorkTypes.filter((x: any) => x.value == taskValues.accountWorkTypeId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="accountWorkTypesArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.accountWorkTypes}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal d-flex align-items-center gap-1">
                                                    {/* {t(`Billable`)} */}
                                                    {getValueFromResource('Billable', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Specify whether time logged against this task can be billed to the client', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input
                                                        className="form-check-input h-20px w-30px  mt-2"
                                                        type='checkbox'
                                                        name='isBillable'
                                                        checked={taskValues.isBillable}
                                                        onChange={(e) => { onSwitch(e) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Billing Rate Start Date')} */}
                                                    {getValueFromResource('Billing Rate Start Date', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={taskValues.billingRateStartDate}
                                                        onChange={(date) => onDateChange(date, "billingRateStartDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Billing Rate End Date')} */}
                                                    {getValueFromResource('Billing Rate End Date', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <DatePicker
                                                        selected={taskValues.billingRateEndDate}
                                                        onChange={(date) => onDateChange(date, "billingRateEndDate")}
                                                        calendarStartDay={calendarStartDay}
                                                        className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                        dateFormat={CurrentCultureDateFormat.toString()}
                                                    >
                                                    </DatePicker>
                                                    <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Employee Rate Currency')} */}
                                                    {getValueFromResource('Employee Rate Currency', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.employeeCurrencyRate.filter((x: any) => x.value == taskValues.employeeRateCurrencyId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="employeeCurrencyArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.employeeCurrencyRate}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {getValueFromResource('Employee Rate', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The internal cost rate used to calculate the labor cost for work performed on this task.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="wrapper">
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='employeeRate'
                                                        value={taskValues.employeeRate}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setTaskValues({...taskValues, employeeRate: val});
        }
        //setTaskValues({...taskValues, employeeRate: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setTaskValues({...taskValues, employeeRate: formatted});
    }
    }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Billing Rate Currency')} */}
                                                    {getValueFromResource('Billing Rate Currency', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.billingCurrencyRate.filter((x: any) => x.value == taskValues.billingRateCurrencyId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="billingRateCurrencyArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.billingCurrencyRate}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Billing Rate')} */}
                                                    {getValueFromResource('Billing Rate', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The rate charged to the client for billable work performed on this task.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="wrapper">
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='billingRate'
                                                        value={taskValues.billingRate}
                                                        //onChange={onHandleTextChange}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setTaskValues({...taskValues, billingRate: val});
        }
        //setTaskValues({...taskValues, billingRate: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setTaskValues({...taskValues, billingRate: formatted});
    }
}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Advanced' })}>
                                        <div className='row'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Parent Task')} */}
                                                    {getValueFromResource('Parent Task', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Link this task to a parent task to organize work into a hierarchical structure.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={taskResponse.parentTask.filter((x: any) => x.value == taskValues.parentTaskId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="parentTaskArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.parentTask}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Milestone')} */}
                                                    {getValueFromResource('Milestone', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Associate the task with a project milestone to track progress toward key deliverables.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={taskResponse.projectMilestone.filter((x: any) => x.value == taskValues.accountProjectMilestoneId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="projectMilestoneArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.projectMilestone}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Estimated Cost Currency')} */}
                                                    {getValueFromResource('Estimated Cost Currency', dispatch, t)}
                                                </label>
                                                <Select
                                                    value={taskResponse.estimatedCostCurrencies.filter((x: any) => x.value == taskValues.estimattedCostCurrencyId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="estimatedCostCurrenciesArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.estimatedCostCurrencies}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t('Estimated Cost')} */}
                                                    {getValueFromResource('Estimated Cost', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('The projected cost of completing the task based on planned effort and rates.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <div className="wrapper">
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='estimatedCost'
                                                        value={taskValues.estimatedCost}
                                                        //onChange={onHandleTextChange}
onChange={(e) => {
        const val = e.target.value;
        if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
            setTaskValues({...taskValues, estimatedCost: val});
        }
        //setTaskValues({...taskValues, estimatedCost: val});
    }}
    onBlur={(e) => {
        const formatted = formatNumberCustomoriginal(
            cultureInfoName.toString(),
            e.target.value,
            decimalPlaces
        );
        setTaskValues({...taskValues, estimatedCost: formatted});
    }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Estimated Time (Hours)')} */}
                                                    {getValueFromResource('Estimated Time (Hours)', dispatch, t)}
                                                </label>
                                                <div className="wrapper">
                                                    <input
                                                        type="text"
                                                        className="form-control fs-7 fw-normal"
                                                        name='estimatedTime'
                                                        // value={taskValues.estimatedTime}
                                                        // onChange={onHandleTextChange}
                                                        value={values.estimatedTime}
                                                        onChange={(e) => {
                                                            onHandleTextChange(e);
                                                            handleChange('estimatedTime')(e);
                                                        }}
                                                        min="0"
                                                        step="any"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal">
                                                    {/* {t(`Is Parent`)} */}
                                                    {getValueFromResource('Is Parent', dispatch, t)}
                                                </label>
                                                <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                    <input
                                                        className="form-check-input h-20px w-30px  mt-2"
                                                        type='checkbox'
                                                        name='isParent'
                                                        checked={taskValues.isParent}
                                                        onChange={(e) => { onSwitch(e) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Reminders' })}>
                                        <div className='row' style={{ marginBottom: 10 }}>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t(`Reminder Type`)} */}
                                                    {getValueFromResource('Reminder Type', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Select when and how reminders should be sent for this task, such as before the due date or at scheduled intervals.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <Select
                                                    value={taskResponse.taskTeamRemainder.filter((x: any) => x.value == taskValues.taskTeamRemainderId)}
                                                    className="basic-single fs-7 fw-normal"
                                                    classNamePrefix="select"
                                                    name="taskTeamRemainderArray"
                                                    onChange={(e, name) => onChange(e, name)}
                                                    options={taskResponse.taskTeamRemainder}
                                                    styles={dropDownSelectionStyles}
                                                    maxMenuHeight={maxMenuHeight}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                {taskValues.showReminderDays == 'flex' &&
                                                    <>
                                                        <label className="form-label fs-7 fw-normal mb-2">
                                                            {/* {`Reminder Days`} */}
                                                            {getValueFromResource('Reminder Days', dispatch, t)}
                                                        </label>
                                                        <input
                                                            value={taskValues.reminderDays}
                                                            type="number"
                                                            className="form-control fs-7 fw-normal"
                                                            name='reminderDays'
                                                            onChange={onHandleTextChange}
                                                        />
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <div className='row selectAllDiv mb-3'>
                                        </div>
                                        <TaskResource name="RemainderTaskTeam" />
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Other' })}>
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label className="form-label fs-7 fw-normal mb-2">
                                                    {/* {t('Task Description')} */}
                                                    {getValueFromResource('Task Description', dispatch, t)}
                                                </label>
                                                <textarea
                                                    value={taskValues.taskDescription}
                                                    name="taskDescription"
                                                    className="form-control fs-7 fw-normal"
                                                    rows={4}
                                                    onChange={onHandleTextChange}
                                                >
                                                </textarea>
                                            </div>
                                        </div>
                                        <div className='row mt-4'>
                                            <div className="col-md-6">
                                                <label className="form-label fs-7 fw-normal mb-2 d-flex align-items-center gap-1">
                                                    {/* {t(`Task Completed (%)`)} */}
                                                    {getValueFromResource('Task Completed (%)', dispatch, t)}
                                                    <div
                                                        style={{ marginBottom: "2px" }}
                                                        data-tooltip-id="tooltip-description"
                                                        data-tooltip-content={getValueFromResource('Displays the current percentage of task completion to track progress and overall project status.', dispatch, t)}
                                                    >
                                                        <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon"/>
                                                    </div>
                                                </label>
                                                <input
                                                    value={taskValues.taskCompletePercent}
                                                    type="number"
                                                    className="form-control fs-7 fw-normal"
                                                    name='taskCompletePercent'
                                                    onChange={onHandleTextChange}
                                                    disabled={true}
                                                />
                                            </div>


                                            {accountProjectTaskId != 0 ? (
                                                <div className="col-md-6">
                                                    <label className="form-label fs-7 fw-normal mb-2">
                                                        {/* {t(`Disabled`)} */}
                                                        {getValueFromResource('Disabled', dispatch, t)}
                                                    </label>

                                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                        <input
                                                            className="form-check-input h-20px w-30px  mt-2"
                                                            type='checkbox'
                                                            name='isDisabled'
                                                            checked={taskValues.isDisabled}
                                                            onChange={(e) => { onSwitch(e) }}
                                                        />
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className={clsx('tab-pane', { active: tab === 'Attachment' })}>
                                        <AttachmentUpload
                                            Id={Number(accountProjectTaskId)}
                                            onupdateTempAttachmentId={updateTempAttachmentId}
                                            clearRef={attachmentUploadClearRef}
                                            AccountAttachmentTypeId={5}
                                        />
                                        {tab === 'Attachment' && (Number(accountProjectTaskId) && Number(accountProjectTaskId) !== 0) ? (
                                            <GetAttachments Id={Number(accountProjectTaskId)} AccountAttachmentTypeId={5} IsShowEmployeeInformation={false} isDisabled={true} />
                                        ) : null}
                                    </div>
                                    {customFieldsArray && customFieldsArray.length > 0 &&
                                        <div className={clsx('tab-pane', { active: tab === 'CustomField' })}>
                                            <div className='row'>
                                                {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                                    <Fragment key={index}>
                                                        {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3 "}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <Select
                                                                        name={x.DatabaseFieldName}
                                                                        className="basic-single fs-7 fw-normal"
                                                                        onChange={(e: any) => setFieldValue(x.DatabaseFieldName, e?.value)}
                                                                        styles={dropDownSelectionStyles}
                                                                        value={values[x.DatabaseFieldName] ? { value: values[x.DatabaseFieldName], label: values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                                        options={[
                                                                            { value: 'None', label: 'None' },  // Add "None" option at the start
                                                                            ...x.DropDownOptions
                                                                                ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                                : []
                                                                        ]}
                                                                        //options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                                        maxMenuHeight={maxMenuHeight}
                                                                    />
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        {x.MasterCustomDataTypeName == "Date" && (
                                                            <>
                                                                <div key={index} className={"col-md-6 mb-3"}>
                                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                    <div className="wrapper">
                                                                        <DatePicker
                                                                            name={x.DatabaseFieldName}
                                                                            //onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                            //selected={(values[x.DatabaseFieldName] ? moment(values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                            onChange={(date) => setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(customFieldInsertionFormat) : moment(new Date()).format(customFieldInsertionFormat))}
                                                                            selected={(values[x.DatabaseFieldName] ? dateFormatByAccountCulture(values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                            calendarStartDay={calendarStartDay}
                                                                            className="form-control form-con fs-7 fw-normal col-md-1"
                                                                            dateFormat={CurrentCultureDateFormat.toString()}
                                                                            onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                        />
                                                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                                    </div>
                                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                                        <div style={{ paddingRight: 20 }}>
                                                                            {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                                <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </>
                                                        )}
                                                        {(x.MasterCustomDataTypeName == "Text") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                    onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                    onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {(x.MasterCustomDataTypeName == "Number") && (
                                                            <div key={index} className={"col-md-6 mb-3"}>
                                                                <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                                <input
                                                                    name={x.DatabaseFieldName}
                                                                    id={x.DatabaseFieldName}
                                                                    value={values[x.DatabaseFieldName] ? values[x.DatabaseFieldName] : ''}
                                                                    //onChange={handleChange(`${x.DatabaseFieldName}`)}
                                                                        onChange={(e) => {
                                                                            const value = e.target.value;
                                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                                setFieldValue(x.DatabaseFieldName, value);
                                                                            }
                                                                        }}
                                                                        onBlur={(e) => {
                                                                            const formatted = formatNumberCustomoriginal(
                                                                                cultureInfoName.toString(),
                                                                                e.target.value,
                                                                                decimalPlaces
                                                                            );
                                                                                    setFieldValue(x.DatabaseFieldName, formatted);

                                                                        }}
                                                                    className={"form-control form-con input-sm custom-field custom-field"}
                                                                    //max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                                    //min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                                    required={x.IsRequired ? x.IsRequired : ""}
                                                                    type="text"
                                                                    //onBlur={() => handleBlurValidateAll(setFieldTouched, values, validateForm)}
                                                                />
                                                                {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                                    <div style={{ paddingRight: 20 }}>
                                                                        {touched[x.DatabaseFieldName] && errors[x.DatabaseFieldName] &&
                                                                            <p className='errorMsg'>{errors[x.DatabaseFieldName] as string}</p>
                                                                        }
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </Fragment>
                                                )}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>}
                            {showErrorSummary && Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>
                                        {/* {t('Error Summary')}: */}
                                        {getValueFromResource('Error Summary', dispatch, t)}:
                                    </strong>
                                    <ul>
                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{errors[fieldName] as string}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                    onClick={handleCloseOnClickEvent}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel', dispatch, t)}
                                </button>
                                <button
                                    className='btn btn-sm btn-primary'
                                    type='button'
                                    data-kt-element='send'
                                    onClick={() => {
                                        setShowErrorSummary(true);
                                        handleSubmit();
                                    }}
                                // onClick={() => handleSubmit()}
                                // disabled={!isValid}
                                >
                                    {/* {t('Save')} */}
                                    {getValueFromResource('Save', dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
             {/* <ReactTooltip id="tooltip-description" style={TOOLTIP_STYLE} place="top" delayShow={100} delayHide={100} clickable /> */}
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}
export default TaskAddAndUpdate